export default __webpack_public_path__ + "static/media/cushionCover.818d088c.jpg";